var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgAdvancedPatternVirtual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5745 43.0433H5.49889C1.7687 43.0433 -0.648008 39.1063 1.04041 35.7802L17.7451 2.87199C19.6058 -0.793685 24.8492 -0.772462 26.6802 2.90815L43.0512 35.8163C44.7047 39.1402 42.287 43.0433 38.5745 43.0433Z",
    fill: "#EFD470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgAdvancedPatternVirtual);
export default __webpack_public_path__ + "static/media/progAdvancedPatternVirtual.9465d30934e0941d98a53b4015009477.svg";
export { ForwardRef as ReactComponent };